import { render } from "./Pane.vue?vue&type=template&id=0942a5d4&scoped=true"
import script from "./Pane.vue?vue&type=script&lang=js"
export * from "./Pane.vue?vue&type=script&lang=js"

import "./Pane.vue?vue&type=style&index=0&id=0942a5d4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0942a5d4"]])

export default __exports__